import { type ComponentProps } from 'react';
import { Root, Thumb } from '@radix-ui/react-switch';

import { cn } from '@/util/utils';

/**
 * ui-switch, READ 100:1774: a 44x20 track with a 2px transparent border, a 16px knob on the
 * background colour with shadow-lg, primary when on. The title-and-description row the
 * design draws around it is composition in the screen, not part of this component.
 */
function Switch({ className, ref, ...props }: ComponentProps<typeof Root>) {
    return (
        <Root
            data-slot="switch"
            ref={ref}
            className={cn(
                'peer bg-input inline-flex h-5 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent',
                'focus-visible:outline-ring transition-colors duration-(--duration-fast) outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-solid',
                'data-[state=checked]:bg-primary disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        >
            <Thumb
                data-slot="switch-thumb"
                className="bg-background pointer-events-none block size-4 rounded-full shadow-lg transition-transform duration-(--duration-fast) data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0"
            />
        </Root>
    );
}

export { Switch };
